import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Packages from '../../components/Packages/LogoDesignPackages';
import mobile_img from "../../images/logo_design/mobile_img.png";
import LogoDesign1 from "../../images/logo_design/LogoDesignServices1.gif"
import LogoDesign2 from "../../images/logo_design/LogoDesignServices2.gif"
import LogoDesign3 from "../../images/logo_design/LogoDesignServices3.gif"
import LogoDesign4 from "../../images/logo_design/LogoDesignServices4.gif"
import LogoDesign5 from "../../images/logo_design/LogoDesignServices5.gif"
import LogoDesign6 from "../../images/logo_design/LogoDesignServices6.gif"
import LogoDesign7 from "../../images/logo_design/LogoDesignServices7.gif"
import LogoDesign8 from "../../images/logo_design/LogoDesignServices8.gif"
import LogoDesign9 from "../../images/logo_design/LogoDesignServices9.gif"
import LogoBrandGuide1 from "../../images/logo_design/LogoBrandGuide1.jpg";
import LogoBrandGuide2 from "../../images/logo_design/LogoBrandGuide2.jpg";
import LogoDesignTestimonial from '../../components/Testimonials/LogoDesignTestimonial';
import { Link } from 'react-router-dom'
import Bg from '../../images/shapes/memecoin_bg_shape_1.svg'
import Bg2 from '../../images/shapes/btn_mask_bg.png'
import shape3 from '../../images/shapes/shape_chain_1.svg'
import shape4 from '../../images/shapes/shape_chain_2.svg'
import Modal from '../../components/Modal/Modal';

const LogoDesignPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (
        <Fragment>
            <div className='index_memecoin page_wrapper'>
                <Header />
                <main className="page_content">

                    {/* Hero */}

                    <section className="memecoin_hero_section section_decoration text-center" style={{ backgroundImage: `url(${Bg})` }}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <h1 className="hero_title text-uppercase" data-aos="fade-up" data-aos-duration="800" style={{ fontSize: '4rem' }}>
                                        Craft <mark>Memorable</mark> Brand Identities With Creative <mark>Logo</mark> and <mark>Branding</mark>.
                                    </h1>
                                    <p className="hero_description" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                        We specialize in delivering ultimate brand identities through our creative logo and branding solutions.
                                    </p>
                                    <ul className="btns_group unordered_list justify-content-center p-0" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
                                        <li>
                                            <button className="memecoin_btn bg-light" onClick={openModal}>
                                                <span className="btn_label">Get a Free Quote</span>
                                                <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="decoration_item shape_chain_1">
                            <img src={shape3} alt="Shape Chain" />
                        </div>
                        <div className="decoration_item shape_chain_2">
                            <img src={shape4} alt="Shape Chain" />
                        </div>
                    </section>

                    <section id="id_token_offer" className="memecoin_countdown_section section_decoration mt-5 pt-5">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <img src={mobile_img} alt="mobile_img" />
                                </div>
                                <div className="col-lg-6">
                                    <div className="memecoin_heading_block" data-aos="fade-up" data-aos-duration="800">
                                        <h2 className="heading_text text-uppercase pt-4">
                                            LOGO DESIGNING
                                        </h2>
                                        <p className="heading_description pe-lg-5 mt-5">
                                            Perfect logo design services
                                        </p>
                                        <p className="heading_description pe-lg-5 mt-5">
                                            Take your brand's identity to a whole new level.
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            GetLogoAndWebsite is your go-to logo design agency if you want a brand that stands out. We make eye-catching logos to match your preferences and showcase your brand's identity differently. With years of experience, we know how to handle our work properly. No matter what your business size or what your business type is. We always try our best to get every detail of your work right. Our goal is to design a logo that can actually be beneficial for you and help your business grow faster and better.
                                        </p>

                                        <p className="heading_description pe-lg-5 mt-5">
                                            Uplift the face of your company
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            A well-made and creatively designed logo works as the public face of your company and leaves a great impression on your targeted niche. Our logo design services are focused on showcasing the unique image of your agency in a visually appealing logo.
                                        </p>

                                        <p className="heading_description pe-lg-5 mt-5">
                                            Make Your Brand Shine With 3D Logos, and give great impressions!
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            One of our services includes 3D logo design, in which we provide your company with a more captivating and bold logo in 3D. We use top-notch software and our experience to create 3D logos that take your brand to new heights. We try to give your brand the life that it deserves!
                                        </p>

                                        <p className="heading_description pe-lg-5 mt-5">
                                            Striking Logo Designs: Uncovering Your Brand's Potential
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            Our agency, GetLogoAndWebsite, does everything with passion and great effort. We try our best to generate unique and outstanding modern designs, which helps your business grow faster than ever. From the initial process, we go beyond our limitations and explore bold ideas that are used to drive attention and interest in today's world. Every logo we create and every project we deliver is carefully designed and thoroughly inspected to ensure accuracy and avoid mistakes. We consider it more than just a logo.
                                        </p>

                                        <p className="heading_description pe-lg-5 mt-5">
                                            Why should you Choose GetLogoAndWebsite for all your logo design needs?
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            When you let GetLogoAndWebsite take care of your design needs, you get access to a team full of passionate professionals who are committed to your success. Creating logo designs that help you grow your brand more easily is our core motive. Our logo designs are a mix of creativity, insights, and thorough research. We try to work closely with our clients to deliver exceptional results.
                                        </p>

                                        <p className="heading_description pe-lg-5 mt-5">
                                            Elevate Your Brand with GetLogoAndWebsite
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            Ready to take the first step to success?
                                        </p>

                                        <p className="heading_description pe-lg-5 mt-5">
                                            Get a free quote today to start the initial process for taking your logo game to a whole new level. Our team is always looking forward to bringing your brand vision to reality and helping your design game stand out in today's market.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section
                        id="id_memecoin_service_section"
                        className={`memecoin_service_section z-2 position-relative`}
                    >
                        <div className="container">
                            <div className="memecoin_heading_block text-center">
                                <h2 className="heading_text text-uppercase mb-0">
                                    LOGO DESIGNING
                                </h2>
                                <p className='mt-4'>
                                    Logo design acts as a very important aspect of creating a strong brand identity. GetLogoAndWebsite understands the importance of a well-crafted and precisely designed logo in presenting the first impression of your business and establishing a visual representation. Our team of talented designers has the expertise and creative flair required to design outstanding logos that are unique, impactful, and aligned with your brand's vision.
                                </p>
                            </div>

                            <div className="row">
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign1} alt="logo design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign2} alt="logo design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign3} alt="logo design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign4} alt="logo design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <div className="memecoin_iconbox_block">
                                        <img src={LogoDesign5} alt="logo design" />
                                    </div>
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign6} alt="logo design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign7} alt="logo design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign8} alt="logo design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={LogoDesign9} alt="logo design" />
                                </div>
                            </div>
                        </div>
                    </section>


                    <section id="id_token_offer" className="memecoin_countdown_section section_decoration">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <div className="memecoin_heading_block" data-aos="fade-up" data-aos-duration="800">
                                        <h2 className="heading_text text-uppercase">
                                            Shaping Brands with Great 3D Logo Designs
                                        </h2>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            At our agency, we provide 3D logo design services that change the way businesses appear. We bring new levels of impactful visual identity through logo design. 3D logos helped businesses gain new heights against their competition, as they look visually appealing and grab the attention easily. It leaves a good impact on the customers, and they are likely to remember the distinction of your brand's logo.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 d-flex gap-5">
                                    <img src={LogoBrandGuide1} alt="LogoBrandGuide1" style={{ marginLeft: 'auto' }} />
                                    <img src={LogoBrandGuide2} alt="LogoBrandGuide2" style={{ marginLeft: 'auto' }} />
                                </div>
                            </div>
                        </div>
                    </section>

                    <Packages />
                    <LogoDesignTestimonial />

                </main>
                <Footer />
                <Scrollbar />
            </div>
            {isModalOpen && <Modal onClose={closeModal} />}
        </Fragment>
    )
};
export default LogoDesignPage;